import { useState, useEffect } from 'react'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import clsx from 'clsx'
import IconSuccess from '@/components/icons/IconSuccess'
import IconError from '@/components/icons/IconError'
import {
  popupNotificationListState,
  latestNotificationValue
} from '@/recoil/Notification'
import {
  NOTIFICATION_STATUS_MAP,
  NOTIFICATION_TEXT_MAP
} from '@/constants/notification'
import './PopupNotification.css'

const ANIMATION_TIME = 300
const NOTIFICATION_LIFE_TIME = 3000

function Notification({ id, status, message }) {
  const setPopupNotification = useSetRecoilState(popupNotificationListState)
  const [active, setActive] = useState(false)
  useEffect(() => {
    let delayDestroyTimer
    const initialTimer = setTimeout(() => setActive(true), 10)
    const destroyTimer = setTimeout(() => {
      setActive(false)
      delayDestroyTimer = setTimeout(
        () => setPopupNotification({ remove: true }),
        ANIMATION_TIME
      )
    }, NOTIFICATION_LIFE_TIME)

    return () => {
      clearTimeout(initialTimer)
      clearTimeout(destroyTimer)
      clearTimeout(delayDestroyTimer)
    }
  }, [id, setPopupNotification])

  const isSuccess = status === 'success'

  return (
    <div
      className={clsx('popup-notification', {
        [status]: true,
        active
      })}
    >
      <div className="popup-notification-status-icon">
        {isSuccess ? <IconSuccess /> : <IconError />}
      </div>
      <div className="popup-notification-message">{message}</div>
    </div>
  )
}

export default function PopupNotification() {
  const [popupNotificationList, setPopupNotificationList] = useRecoilState(
    popupNotificationListState
  )
  const latestNotification = useRecoilValue(latestNotificationValue)

  useEffect(() => {
    if (
      latestNotification.initial ||
      latestNotification.markRead !== 0 ||
      !latestNotification.status
    ) {
      return
    }
    const {
      orderId = '#',
      status = '#',
      message,
      timestamp = '#',
      tradeId = '#'
    } = latestNotification
    const key = `${orderId}_${status}_${timestamp}_${tradeId}`
    const isError = status === NOTIFICATION_STATUS_MAP.rejected
    setPopupNotificationList({
      notification: {
        key,
        status: isError ? 'error' : 'success',
        message: NOTIFICATION_TEXT_MAP[status] || message || status
      }
    })
  }, [latestNotification, setPopupNotificationList])

  const NotificationStack = popupNotificationList.map(
    ({ key, status, message }, index) => (
      <Notification key={key} id={key} status={status} message={message} />
    )
  )

  return <div className="popup-notification-container">{NotificationStack}</div>
}
